import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OperacaoFinanceiraEditarComponent } from './operacao-financeira-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: OperacaoFinanceiraEditarComponent }
    ])],
    exports: [RouterModule]
})
export class OperacaoFinanceiraEditarRoutingModule { }
